<app-preloader></app-preloader>

<ng-container *ngIf="!( location == '/login' || location == '/register')">
    <app-header></app-header>
        <router-outlet>            
        </router-outlet>
    <app-footer></app-footer>
    <app-whatsapp></app-whatsapp>
</ng-container>

<ng-container *ngIf="(location == '/login' || location == '/register')">
    <router-outlet>
    </router-outlet>
</ng-container>